var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vld-parent"},[_c('loading',{attrs:{"active":true,"is-full-page":true,"color":"#007aff","opacity":_vm.opacity}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }